/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrosoftTeamsRegular from './microsoft-teams-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MicrosoftTeamsRegular {...validProps} />;
}
SvgComponent.iconName = 'microsoftTeamsRegular';

export const MicrosoftTeamsRegularIcon = svgIconWrapper(SvgComponent);
